export const CONTACT_US_CONSTANTS = {
  CONTACT_US: "Talk To Our Sales Team",
  CONTACT_US_DESC: [
    "Onemind Services Sales is here to provide assistance with large deployments, cloud migrations, cloud cost comparisons, and proof of concepts.",
  ],
  CONTACT_US_FORM_TITLE: "Send Onemind Services Sales a Message",
  CONTACT_US_FORM_TITLE_TEXT:
    "Onemind Services Sales is here to provide assistance with large deployments, cloud migrations, cloud cost comparisons, and proof of concepts.",
};
